"use client";
import { createContext } from "react";

export const Initialload = createContext<any>(null);
